import React from 'react';
import { useCopilot } from './CopilotContext';
import { CURRENT_STAGE, Stage } from 'src/contstant/apiEndpoints';
import { ASTRA_ICON_URL } from './brand';
import './Copilot.scss';

// Feature flag: show copilot in beta, gamma (and test/local dev)
const COPILOT_ENABLED_STAGES: Set<Stage> = new Set([Stage.TEST, Stage.BETA, Stage.GAMMA]);

// TEMPORARY prod allowlist: show Astra in prod only for these users while it is being rolled out.
// Add aliases here to grant early access; remove this list (and the prod carve-out in
// isCopilotVisibleForUser) once Astra is fully enabled in prod.
const PROD_ALLOWLISTED_USERS: Set<string> = new Set(['oggurram', 'shpragy']);

/** Whether the Astra trigger should be shown for the given stage + user. */
export function isCopilotVisibleForUser(stage: Stage, userId: string): boolean {
  if (COPILOT_ENABLED_STAGES.has(stage)) return true;
  // TEMPORARY: prod is gated to the allowlist until Astra is fully enabled.
  return stage === Stage.PROD && PROD_ALLOWLISTED_USERS.has(userId);
}

interface CopilotTriggerProps {
  isAuthenticated: boolean;
}

export function CopilotTrigger({ isAuthenticated }: CopilotTriggerProps) {
  const { state, userId, togglePanel } = useCopilot();

  if (!isCopilotVisibleForUser(CURRENT_STAGE, userId)) return null;
  if (!isAuthenticated || state.isOpen) return null;

  // Custom FAB instead of a Cloudscape Button: Button caps iconUrl at 16px, too small for
  // the launcher. Image is decorative (alt=""); accessible name comes from aria-label.
  return (
    <div className="copilot-trigger">
      <button
        type="button"
        className="copilot-trigger-button"
        onClick={togglePanel}
        aria-label="Open Astra"
      >
        <img className="copilot-trigger-icon" src={ASTRA_ICON_URL} alt="" />
      </button>
    </div>
  );
}
